import { createLucideIcon } from "lucide-react";

export const RemoveCircle = createLucideIcon(
    "RemoveCircle",
    [
        [
            "path",
            {
                d: "M16 12L8 12",
                key: "9qx0n8",
            },
        ],
        [
            "path",
            {
                d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z",
                key: "170qnq",
            },
        ],
    ],
);
